import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 16"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M15.7 7.112 8.7.269C8.6.17 8.5.073 8.4.073c-.2-.097-.5-.097-.8 0-.1.098-.2.098-.3.196l-7 6.843a.93.93 0 0 0 0 1.368.98.98 0 0 0 1.4 0L7 3.3v11.34c0 .586.4.977 1 .977s1-.391 1-.978V3.299l5.3 5.182c.2.195.5.293.7.293s.5-.098.7-.293a.93.93 0 0 0 0-1.37"
    }, null, -1)
  ]))]))
}
export default { render: render }